<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t('viewSettings.diagnostics.title') }}
    </h3>

    <v-data-table
        :loading="!isLoadedDiagnosticParameters"
        :headers="[
                    {text: this.$t('common.type'), value: 'type', sortable: true},
                    {text: this.$t('common.doesnt_show'), value: 'config.is_hidden', sortable: true},
                    {text: this.$t('common.optional'), value: 'config.is_optional', sortable: true},
                ]"
        :items="diagnosticParameters"
        :options="{
                    itemsPerPage: 100
                  }"
        elevation="0"
        :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:item="props">
        <tr>
          <td class="text-xs-left">

            {{$t('windowDiagnostic.parameters.'+props.item.type)}}
          </td>
          <td class="text-xs-left">
            <v-simple-checkbox :disabled="!!nowUpdatingConfigForParameterWithId" v-if="nowUpdatingConfigForParameterWithId!==props.item.id" @click="toggle(props.item, 'is_hidden', !(props.item.config && props.item.config.is_hidden))" :value="props.item.config && props.item.config.is_hidden"></v-simple-checkbox>
            <v-progress-circular
                indeterminate
                color="primary"
                size="20"
                v-if="nowUpdatingConfigForParameterWithId===props.item.id"
            ></v-progress-circular>
          </td>
          <td class="text-xs-left">
            <v-simple-checkbox :disabled="!!nowUpdatingConfigForParameterWithId" v-if="nowUpdatingConfigForParameterWithId!==props.item.id" @click="toggle(props.item, 'is_optional', !(props.item.config && props.item.config.is_optional))" :value="props.item.config && props.item.config.is_optional"></v-simple-checkbox>
            <v-progress-circular
                indeterminate
                color="primary"
                size="20"
                v-if="nowUpdatingConfigForParameterWithId===props.item.id"
            ></v-progress-circular>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';

export default {
  name: "Posts",
  created() {
    this.onLoad();
  },
  watch: {
    '$route'(to, from) {
      this.onLoad();
    }
  },
  computed: {
    ...mapFields('diagnostics', ['diagnosticParameters', 'isLoadedDiagnosticParameters', 'nowUpdatingConfigForParameterWithId'])
  },
  methods: {
    toggle(item, option, value){
      this.$store.dispatch('diagnostics/setParameterConfig',
          {
            id:item.id,
            option,
            value
          });
    },
    onLoad() {
      this.$store.dispatch('diagnostics/getParameters');
    },
  }
}
</script>

<style scoped>

</style>